module.exports = __webpack_public_path__ + "img/companyInside3.8407947d.jpg";